/**
 * Appended to Term Type / Settlement Type tooltips when the corresponding org flag is off,
 * so users know capability is limited until enabled for their environment.
 */
export const OPEN_TERM_SUPPORT_COMING_SOON = '(Open Term support is coming soon)';
export const PHYSICAL_SETTLEMENT_SUPPORT_UPCOMING = '(Physical settlement support is upcoming)';

/**
 * When `featureEnabled` is false, appends `suffix` to the base tooltip (or returns suffix alone if base is empty).
 * When `featureEnabled` is true, returns `base` unchanged.
 */
export function appendTooltipWhenFeatureDisabled(
  base: string | undefined,
  featureEnabled: boolean,
  suffix: string
): string | undefined {
  if (featureEnabled) {
    return base;
  }
  if (base == null || base === '') {
    return suffix;
  }
  return `${base} ${suffix}`;
}
